import { createApiClient } from '@deltax/idp-api-client'
import qs from 'qs'
import {
  requestSessionTokenFromParent,
  handleEmbedFlowError,
  isTokenVersionRevoked,
  getIsSessionRevoked,
} from '@/helpers/embedHelper'
import appConfig from '@/constants/appConfig'

export const isEmbedded = window.self !== window.top;

export const activeClientId = isEmbedded 
  ? import.meta.env.VITE_EMBED_CLIENT_APP_ID 
  : (import.meta.env.VITE_DELTAX_CLIENT_APP_ID || appConfig.STUNNR_CLIENT_ID);

export const { apiClient, authService } = createApiClient({
  clientId: activeClientId,
  resourceApiBaseUrl: import.meta.env.VITE_DX_API_URL,
  idpBaseUrl: import.meta.env.VITE_IDP_BASE_URL,
  isEmbedMode: isEmbedded,
  accessTokenStorageKey: isEmbedded ? (import.meta.env.VITE_EMBED_ACCESS_TOKEN_STORAGE_KEY || 'dx_embed_access_token') : undefined,
  errorHandler: isEmbedded ? async (err) => {
    if (err?.name === 'AuthRefreshError' || (err instanceof Error && err.name === 'AuthRefreshError')) {
      if (isTokenVersionRevoked(err)) {
        handleEmbedFlowError(err);
        return;
      }

      if (getIsSessionRevoked()) {
        return;
      }

      try {
        const currentPath = window.location.pathname + window.location.search + window.location.hash;
        if (!currentPath.startsWith('/login') && !currentPath.startsWith('/callback')) {
          sessionStorage.setItem('dx_internal_redirect', currentPath);
        }

        const sessionToken = await requestSessionTokenFromParent();
        const authorizeUrl = await authService.createAuthorizationUrl(
          `${window.location.origin}/callback`,
          undefined,
          import.meta.env.VITE_RESOURCE,
          sessionToken
        );
        window.onbeforeunload = null;
        window.location.href = authorizeUrl;
      } catch (bootstrapErr) {
        handleEmbedFlowError(bootstrapErr || err);
      }
    }
  } : undefined
});

const paramsSerializer = (params: Record<string, any>) =>
  qs.stringify(params, { arrayFormat: 'indices', allowDots: true })

apiClient.axiosInstance.defaults.paramsSerializer = paramsSerializer
